import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useStudioApi, errMsg } from "@/lib/api";

const FIELDS = ["title", "artist", "album"];

export const EditTrackDialog = ({ track, onClose, onSaved }) => {
  const call = useStudioApi();
  const [form, setForm] = useState({});
  useEffect(() => { if (track) setForm({ title: track.title || "", artist: track.artist || "", album: track.album || "", bpm: track.bpm ? String(track.bpm) : "" }); }, [track]);

  const save = async () => {
    if (!form.title?.trim()) return toast.error("Title is required");
    const { bpm, ...rest } = form;
    const body = { ...rest, bpm: bpm ? Number(bpm) : 0 };
    try { await call("patch", `/studio/tracks/${track.id}`, body); toast.success("Track updated"); onSaved(); }
    catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <Dialog open={!!track} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[color:var(--lr-card)] border-white/10" data-testid="studio-edit-track-dialog">
        <DialogHeader><DialogTitle className="font-display text-3xl">Edit track</DialogTitle></DialogHeader>
        <div className="flex flex-col gap-4">
          {FIELDS.map((f) => (
            <div key={f} className="flex flex-col gap-1.5">
              <Label className="capitalize">{f}</Label>
              <Input value={form[f] || ""} onChange={(e) => setForm({ ...form, [f]: e.target.value })} data-testid={`studio-edit-${f}-input`} />
            </div>
          ))}
          <div className="flex flex-col gap-1.5">
            <Label>BPM (drives the visualizer)</Label>
            <Input type="number" min={40} max={240} step="0.1" value={form.bpm || ""} onChange={(e) => setForm({ ...form, bpm: e.target.value })} data-testid="studio-edit-bpm-input" />
            <p className="text-xs text-[color:var(--lr-muted)]">Auto-detected. If the lights pulse twice as fast or half as slow as the beat, halve or double it. Clear it to go back to auto.</p>
          </div>
        </div>
        <DialogFooter>
          <button onClick={onClose} className="rounded-lg border border-white/15 px-4 py-2" data-testid="studio-edit-cancel-button">Cancel</button>
          <button onClick={save} className="rounded-lg bg-[color:var(--red)] px-4 py-2 font-bold" data-testid="studio-edit-save-button">Save</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
